export default {
  xeroChartOfAccounts: undefined,
};
